import React, { useState, useEffect } from 'react'
import { navigate } from 'gatsby'

function makeGatsbyAdapter() {
  // Create a fallback location object for SSR
  const fallbackLocation = {
    pathname: '/',
    search: '',
    hash: '',
    state: null,
    key: 'default',
  }

  const adapter = {
    replace(location) {
      if (typeof window !== 'undefined') {
        navigate(location.search || '?', { replace: true })
      }
    },
    push(location) {
      if (typeof window !== 'undefined') {
        navigate(location.search || '?', { replace: false })
      }
    },
    get location() {
      // Use window.location as fallback for SSR compatibility
      if (typeof window !== 'undefined') {
        return {
          pathname: window.location.pathname,
          search: window.location.search,
          hash: window.location.hash,
          state: null,
          key: 'browser',
        }
      }
      // Fallback for SSR
      return fallbackLocation
    },
  }
  return adapter
}

export const GatsbyAdapter = ({ children }) => {
  const [adapter] = useState(makeGatsbyAdapter)
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  // During SSR or initial render, provide a safe adapter
  if (!isClient) {
    const ssrAdapter = {
      replace: () => {},
      push: () => {},
      location: {
        pathname: '/',
        search: '',
        hash: '',
        state: null,
        key: 'ssr',
      },
    }
    return children(ssrAdapter)
  }

  return children(adapter)
}
